import { Badge, Button, EmptyState, Field, Input, Spinner } from "./ui.jsx";
import { formatPriceRange } from "../utils/productSearch.js";
import styles from "./ProductSearch.module.css";

const ProductSearch = ({
  id,
  query,
  onQueryChange,
  results,
  searching,
  selectedId,
  onSelect,
  hasNextPage,
  onLoadMore,
  loadingMore,
}) => {
  const typed = String(query || "").trim();
  const selected = Boolean(selectedId);

  return (
    <div className={styles.wrap}>
      {selected ? null : (
        <Field
          id={id}
          label="Buscar outro produto"
          hint={searching ? "Buscando..." : "Busque pelo nome ou SKU. Só listamos o que a política da loja aceita."}
        >
          <Input
            id={id}
            value={query}
            placeholder="Nome ou SKU do produto"
            autoComplete="off"
            onChange={(event) => onQueryChange(event.target.value)}
          />
        </Field>
      )}

      {searching ? <Spinner label="Buscando produtos..." /> : null}

      {!selected && !searching && typed.length > 0 && typed.length < 2 ? (
        <EmptyState
          title="Continue digitando"
          description="Use pelo menos 2 caracteres para buscar."
        />
      ) : null}

      {!selected && !searching && typed.length === 0 ? (
        <EmptyState
          title="Busque o produto desejado"
          description="Digite o nome ou o SKU. A busca respeita as coleções e a política de troca da loja."
        />
      ) : null}

      {!selected && !searching && typed.length >= 2 && results.length === 0 ? (
        <EmptyState
          title="Nenhum produto encontrado"
          description="Tente outro nome ou SKU. Se não aparecer, a loja não autoriza esse item na troca."
        />
      ) : null}

      {!selected && !searching && results.length > 0 ? (
        <div className={styles.results} role="listbox" aria-label="Produtos encontrados">
          {results.map((entry) => {
            const isSelected = String(selectedId) === String(entry.product.product_id || entry.product.id);
            return (
              <button
                key={entry.product.product_id || entry.product.id}
                type="button"
                role="option"
                aria-selected={isSelected}
                className={`${styles.result} ${isSelected ? styles.selected : ""}`}
                onClick={() => onSelect(entry.product)}
              >
                {entry.product.image ? (
                  <img src={entry.product.image} alt="" />
                ) : (
                  <div className={styles.fallback} aria-hidden="true" />
                )}
                <span className={styles.body}>
                  <strong>{entry.product.title}</strong>
                  <span className={styles.meta}>
                    {formatPriceRange(entry.summary.minPrice, entry.summary.maxPrice) || "Preço sob consulta"}
                  </span>
                  <span className={styles.badges}>
                    <Badge tone={entry.summary.available ? "success" : "warning"}>
                      {entry.summary.available ? "Em estoque" : "Esgotado"}
                    </Badge>
                  </span>
                </span>
              </button>
            );
          })}
          {hasNextPage ? (
            <Button
              type="button"
              variant="secondary"
              loading={loadingMore}
              onClick={onLoadMore}
            >
              Carregar mais
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default ProductSearch;
